module.exports = __webpack_public_path__ + "static/images/card.a113b30.png";